function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "View",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  opacity: 0.739792597
}, React.createElement("g", {
  transform: "translate(2.000000, 2.000000)",
  fill: "#8B8B8B",
  fillRule: "nonzero",
  id: "Shape"
}, React.createElement("path", {
  d: "M18.1574796,5.16431577 C17.9954562,4.95340285 14.1349853,0 9.20446575,0 C4.27394625,0 0.413298219,4.95340285 0.251451953,5.16411352 C0.0980008642,5.36420606 0.0980008642,5.63559169 0.251451953,5.83568423 C0.413298219,6.04659715 4.27394625,11 9.20446575,11 C14.1349853,11 17.9954562,6.04656344 18.1574796,5.83585277 C18.3111432,5.63579394 18.3111432,5.36420606 18.1574796,5.16431577 Z M9.20446575,9.86207478 C5.57261287,9.86207478 2.42704267,6.57440191 1.49588644,5.49961235 C2.42583829,4.42387897 5.56481988,1.13792522 9.20446575,1.13792522 C12.8361415,1.13792522 15.9814992,4.42502505 16.9130451,5.50038765 C15.9830932,6.57608732 12.8441116,9.86207478 9.20446575,9.86207478 Z"
}), React.createElement("path", {
  d: "M9.37603325,2 C7.51452302,2 6,3.48386466 6,5.3076925 C6,7.13152034 7.51452302,8.615385 9.37603325,8.615385 C11.2375435,8.615385 12.7520665,7.13152034 12.7520665,5.3076925 C12.7520665,3.48386466 11.2375435,2 9.37603325,2 Z M9.37603325,7.51279906 C8.13495976,7.51279906 7.12536664,6.52361039 7.12536664,5.3076925 C7.12536664,4.09177461 8.1349931,3.10258594 9.37603325,3.10258594 C10.6170734,3.10258594 11.6266999,4.09177461 11.6266999,5.3076925 C11.6266999,6.52361039 10.6171067,7.51279906 9.37603325,7.51279906 Z"
})));

var SvgPreview = function SvgPreview(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "23px",
    height: "15px",
    viewBox: "0 0 23 15",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPreview, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/preview.a590c3f5.svg";
export { ForwardRef as ReactComponent };